import Vue from 'vue';
import Router from 'vue-router';
import login from '@/components/yj/login';
import home from '@/components/yj/home';

import trade from '@/components/yj/trade';
import market from '@/components/yj/market';
import tradeDetail from '@/views/TradeDetail/TradeDetail';
import condition from '@/views/condition/condition.vue';
import person from '@/views/Person/Person';

import recharge from '@/views/Person/Recharge/Recharge';
import drawmoney from '@/views/Person/DrawMoney/DrawMoney';
import bankCar from '@/views/Person/DrawMoney/BankCar/BankCar';
// import record from '@/views/Person/Record/Record';
import rechargerecord from '@/views/Person/RechargeRecord/RechargeRecord';
import drawmoneyrecord from '@/views/Person/DrawMoneyRecord/DrawMoneyRecord';
import details from '@/views/Person/DrawMoneyRecord/Details/Details';

import kLine from '@/components/common/kLine';

import marketDetail from '@/components/yj/marketDetail';
import userProtocol from '@/components/yj/userProtocol';
import select from '@/components/yj/targetSelected';
import setPage from '@/components/yj/setPage';
import { MessageBox } from 'mint-ui';
import { platform } from 'os';
Vue.use(Router);


function yourCallbackFunction(){

  // window.close();
  let url=window.location.href;
  // alert(url);
  if (url=="file:///android_asset/www/index.html#/") {
    MessageBox.confirm('确认退出应用?').then(action => {
      if (action == 'confirm') {

        navigator.app.exitApp();
      }
    });

  }
  else{
    window.history.back();

  }


};
const router=new Router({

  routes: [
    {
      path: '/',
      name: 'login',
      component: login,
      // redirect: '/home/trade'
    },
    {
      path: '/test',
      name: 'test',
      component: ()=>import('@/components/common/Test/Test.vue'),
      // redirect: '/home/trade'
    },
    // {
    //   path: '/test1',
    //   name: 'test1',
    //   component: ()=>import('@/components/test/condition_test.vue'),
    //   // redirect: '/home/trade'
    // },
    {
      path: '/home',
      name: 'home',
      component: home,
      // redirect: '/home/trade',
      children: [
        {
          path: 'trade',
          name: 'trade',
          component: trade
        },
        {
          path: 'market',
          name: 'market',
          component: market
        },
        {
          path: 'select',
          name: 'select',
          component: select
        },
        {
          path: 'condition',
          name: 'condition',
          component: condition
        },
        {
          path: 'person',
          name: 'person',
          component: person,
        },
      ]
    },
    {
      path: '/tradeDetail/:tableId',
      name: 'tradeDetail',
      component: tradeDetail
    },
    {
      path: '/recharge',
      name: 'recharge',
      component: recharge,
    },
    {
      path: '/drawmoney/:availablemoney?',
      name: 'drawmoney',
      component: drawmoney,
    },
    {
      path: '/bankCar',
      name: 'bankCar',
      component: bankCar,
    },
    {
      path: '/rechargerecord',
      name: 'rechargerecord',
      component: rechargerecord,
    },
    {
      path: '/drawmoneyrecord',
      name: 'drawmoneyrecord',
      component: drawmoneyrecord,
    },
    {
      path: '/details',
      name: 'details',
      component: details,
    },
    {
      path: '/ChangeWord',
      name: 'ChangeWord',
      component: () => import('@/views/ChangeWord/ChangeWord')
    },
    {
      path: '/kLine',
      name: 'kLine',
      component: kLine
    },
    {
      path: '/marketDetail/:contract',
      name: 'marketDetail',
      component: marketDetail
    },
    {
      path: '/userProtocol',
      name: 'userProtocol',
      component: userProtocol
    },
    {
      path: '/setPage',
      name: 'setPage',
      component: setPage
    }

  ]
});


router.beforeEach((to, from, next) => {
  if (platform.name == "android") {
    document.addEventListener("backbutton", yourCallbackFunction, false);
  }
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js